import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MchResolucionesModel } from './MchResoluciones.model';
import { MchResolucionesId } from './MchResoluciones.model';


import * as m from './Prefijo.model';
import { OpcionModel } from '../Global/Opcion.model';

@Component({
	selector: 'prefijo',
	templateUrl: './PrefijoEdit.component.html'
})


export class PrefijoComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public tiposPrefijos: Array<OpcionModel>;
	public tiposFormatos: Array<OpcionModel>;
	public tiposDetalles: Array<OpcionModel>;

	public documentos: Array<OpcionModel>;
	public formatos: Array<OpcionModel>;
	public detalles: Array<OpcionModel>;

	public resolucion: MchResolucionesModel;
	public cantidadMandantes:number = 0;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public prefijo: m.PrefijoModel = new m.PrefijoModel(
		new m.MchPrefijosId("", "", 0),
		new m.DefTiposprefijos(""),
		0,
		new m.ParamFormatos(""),
		new m.ParamDetallefactura(""),
		new m.ParamNegocios(new m.ParamNegociosId("", 0)),
		"",
		"",
		"",
		"", "", "", "", "", 0, "", 0,0,0,2);

	public form: FormGroup;
	public formErrors: any;
	public cnumcont: string;
	private cprefijo: string;
	private cprefijohomologo: string;
	public bloquearCampo: boolean = false;
	public mostrarResolucion: boolean = true;


	public renderResolucion: boolean = true;
	private codigosDocumentosFacturas: Array<string> = ['3', '1', '6', '7'];


	/*	public dataDataBase:NegociosDatabase;
		public dataSource:ExampleDataSource;
		*/
	@ViewChild('filter') filter: ElementRef;



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {


		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		this.formErrors = {


			cprefijo: {},
			nnuminicio: {},
			ntipodoc: {},
			nidformato: {},
			ndetallefact: {},
			vformpago: {},
			vtexto1: {},
			vtexto2: {},
			vtexto3: {},
			vtexto4: {},
			vtexto5: {},
			vtexto6: {},
			ndesde: {},
			nhasta: {},
			nmesesresolucion: {},
			dfechaexpedicion: {},
			dfechavencimiento: {},
			cdescripcion: {},
			ndiasvenc: {},
			cprefijohomologo: {}

		};

		this.resolucion = new MchResolucionesModel(new MchResolucionesId(' ', ' ', 0), ' ', 0, 0, 0, new Date(), new Date());
	}



	ngOnInit() {



		this._route.params.subscribe(params => {
			this.cnumcont = params['cnumcont'];
			this.cprefijo = params['cprefijo'];
			this.cprefijohomologo = params['cprefijohomologo'];
			console.log(params, ' --- ', this.cnumcont, ' --- ', (!!this.cnumcont), ' -- ', (!this.cnumcont));
			if (!this.cnumcont)
				this.cnumcont = '';
			if (!this.cprefijohomologo)
				this.cprefijohomologo = '';
			if (!this.cprefijo)
				this.cprefijo = '';
			else
				this.bloquearCampo = true;

		});



		if (this.cprefijo != "") {
			this._serviciosGenerales.get('detallePrefijo', { cnumcont: this.cnumcont, cprefijo: this.cprefijo }).subscribe(
				x => {

					let result = x[0];
					this.prefijo = new m.PrefijoModel(
						new m.MchPrefijosId(result.cnumcont, result.cprefijo, result.ntipoempresa),
						new m.DefTiposprefijos(result.ntipodoc),
						result.nnuminicio,
						new m.ParamFormatos(result.nidformato),
						new m.ParamDetallefactura(result.ndetallefact),
						new m.ParamNegocios(new m.ParamNegociosId(result.cnumcont, result.ntipoempresa)),
						result.vformpago, result.vtexto1, result.vtexto2, result.vtexto3, result.vtexto4, result.vtexto5, result.vtexto6, result.cdescripcion, result.ndiasvenc, result.cprefijohomologo, result.bloquear,result.nmandatario == 1 ? true : false,result.ncontabiliza == 1 ? true : false,2);
					// this.validarMostrarResolucion();
				},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar el prefijo", "X");
				}
			);

			this._serviciosGenerales.get('detalleResolucion', { cnumcont: this.cnumcont, cprefijo: this.cprefijo }).subscribe(
				result => {
					if (result.length > 0) {
						let x = result[0];
						this.resolucion = new MchResolucionesModel(new MchResolucionesId(x.cnumcont, x.cprefijo, x.ntipoempresa), x.vresolucion, x.ndesde, x.nhasta, x.nmesesresolucion, new Date(x.dfechaexpedicion), new Date(x.dfechavencimiento));


					}
					this.validarMostrarResolucion();
				},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar la resolución", "X");
				});

				this._serviciosGenerales.get('cantidadMandatesPrefijo', {cnumcont: this.cnumcont, cprefijo: this.cprefijo}).subscribe(

					result =>{
		
						console.log("LO QUE TRAJO DE CONSULTAR MANDATES : ",result);
						this.cantidadMandantes = result[0].conteo
					}, 
					error =>{
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de cargar la cantidad de usuarios", "X");
					});


		} else {

			this.prefijo = new m.PrefijoModel(
				new m.MchPrefijosId(this.cnumcont, "", 0),
				new m.DefTiposprefijos(""),
				0,
				new m.ParamFormatos(""),
				new m.ParamDetallefactura(""),
				new m.ParamNegocios(new m.ParamNegociosId(this.cnumcont, 0)),
				"",
				"",
				"",
				"", "", "", "", "", 0, "", 0,0,0,2);
			this.validarMostrarResolucion();
			this._serviciosGenerales.getParametros('PREFIJOS', this.prefijo);


			this.cantidadMandantes = 0



		}


	


		this.cargarListas();

		this.inicializarForm();
		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});
	}


	validarPrefijo() {
		/*this._serviciosGenerales.get('validarPrefijo', {cprefijo : this.prefijo.id.cprefijo, cnumcont : this.prefijo.id.cnumcont}).subscribe(
			result=>{
				if(result[0].c > 0){
					this.openSnackBar('El prefijo : '+this.prefijo.id.cprefijo+' ya existe en el sistema', 'X');
				}
			},error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de validar el prefijo", "X");
			})*/
	}


	verConceptos() {
		this._router.navigate(['/Concepto/i', this.prefijo.id.cnumcont, this.prefijo.id.cprefijo, '2']);
	}

	validarMostrarResolucion() {
		console.log(this.prefijo, ' <------> ', this.codigosDocumentosFacturas.indexOf(String(this.prefijo.defTiposprefijos.ntipodoc)), ' -------- ', String(this.prefijo.defTiposprefijos.ntipodoc));
		if (this.codigosDocumentosFacturas.indexOf(String(this.prefijo.defTiposprefijos.ntipodoc)) > -1 || String(this.prefijo.defTiposprefijos.ntipodoc) == '') {
			console.log('ENTRÓ ....... ');
			this.mostrarResolucion = true;
		} else {
			this.mostrarResolucion = false;
			this.resolucion = new MchResolucionesModel(new MchResolucionesId(' ', ' ', 0), ' ', 0, 0, 0, new Date(), new Date());
			this.prefijo.nnuminicio = 1;

		}

	}

	igualar() {
		this.prefijo.cprefijohomologo = this.prefijo.id.cprefijo
	}

	guardar() {

		this.prefijo.id.cprefijo = this.prefijo.id.cprefijo.split(' ').join('');
        
		if (this.form.valid == false) {
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}
		//console.log(this.prefijo.defTiposprefijos.ntipodoc, '<...................-');
		if (parseInt(this.prefijo.defTiposprefijos.ntipodoc) == 1 || parseInt(this.prefijo.defTiposprefijos.ntipodoc) == 7) {

			/*
			if (this.resolucion.ndesde < 0) {
				this.openSnackBarEspecial('La resolución "Desde" no puede ser menor a 0', 'X');
				return;
			}

			if (this.resolucion.nhasta < 0) {
				this.openSnackBarEspecial('La resolución "Hasta" no puede ser menor a 0', 'X');
				return;
			}

			if (this.resolucion.nmesesresolucion < 0) {
				this.openSnackBarEspecial('Los meses de resolución no puede ser menor a 0', 'X');
				return;
			}

			if (this.resolucion.ndesde > this.resolucion.nhasta) {
				this.openSnackBarEspecial('El campo "Desde" no puede ser mayor al campo "Hasta"', 'X');
				return;
			}

			if (this.resolucion.ndesde == this.resolucion.nhasta) {
				this.openSnackBarEspecial('El campo "Desde" no puede ser igual al campo "Hasta"', 'X');
				return;
			}

			var regex = new RegExp(/^[0-9]*$/);
			console.log(this.resolucion.ndesde , ' <-> ', this.resolucion.nhasta, ' <--> ',(this.resolucion.ndesde == this.resolucion.nhasta));
			if (regex.test(this.resolucion.vresolucion) == false){
				this.openSnackBarEspecial('La resolución no es valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios , ni letras ', 'X');
				return;  
			}
			*/

		} else {
			this.resolucion.vresolucion = '';
			this.resolucion.ndesde = 0;
			this.resolucion.nhasta = 0;
			this.resolucion.nmesesresolucion = 0;
		}

		if (this.prefijo.id.cprefijo == '') {
			this.openSnackBarEspecial('El prefijo no puede estar vacío', 'X');
			return;
		}

		if (this.prefijo.ndiasvenc > 999) {
			this.openSnackBarEspecial('El campo "Días de vencimiento" no puede ser mayor a 3 dígitos', 'X');
			return;
		}

		if (this.prefijo.ndiasvenc < 0) {
			this.openSnackBarEspecial('El campo "Días de vencimiento" no puede ser menor a 0', 'X');
			return;
		}

		if (this.prefijo.ndiasvenc % 1 != 0) {
			this.openSnackBarEspecial('El campo "Días de vencimiento" debe ser un número entero', 'X');
			return;
		}

		if (this.resolucion.nmesesresolucion > 99) {
			this.openSnackBarEspecial('El campo "Meses Resolución" no puede ser mayor a 100', 'X');
			return;
		}

		this._serviciosGenerales.get('validarPrefijo', { cprefijo: this.prefijo.id.cprefijo}).subscribe(
			result => {

				console.log('CUANDO GUARDA : ', result[0].c, ' - ', this.bloquearCampo);
				if (result[0].c > 0 && this.bloquearCampo == false) {
					this.openSnackBarEspecial('El prefijo : ' + this.prefijo.id.cprefijo + ' ya existe en el sistema', 'X');
					return;
				} else {
					this.guardarSinValidaciones();
				}
			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de validar el prefijo", "X");
				return;
			})

	}




	guardarSinValidaciones() {

		console.log(this.prefijo, '<---');
		console.log(this.resolucion, '<---');

		this.prefijo.bloquear = (this.prefijo.bloquear == true ? 1 : 0);
		this.prefijo.nmandatario = (this.prefijo.nmandatario == true ? 1 :0)
		this.prefijo.ncontabiliza = (this.prefijo.ncontabiliza == true ? 1 :0)
		this.prefijo.ncodigopago = 2

		this._serviciosGenerales.post('guardar/prefijo', this.prefijo).subscribe(
			result => {

				this.resolucion.id.cnumcont = this.prefijo.id.cnumcont;
				this.resolucion.id.cprefijo = this.prefijo.id.cprefijo;
				this.resolucion.id.ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa;

				console.log(this.resolucion, '<---');

				this._serviciosGenerales.post('guardar/resolucionPrefijo', this.resolucion).subscribe(
					result => {
						console.log(result);
						this.openSnackBar("Proceso realizado con éxito", "X");
						this._router.navigate(['/Prefijo', this.cnumcont]);
					}, error => {
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de guardar la resolución", "X");
					})

			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de guardar el prefijo", "X");
			})
	}

	addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
		this.completarFecha();
	}

	completarFecha() {
		var temp = this.resolucion.nmesesresolucion;
		if (temp == null)
			temp = -1;
		else if (temp < 0) {
			this.resolucion.nmesesresolucion = 0;
			this.completarFecha();
			return;
		}
		else
			temp = temp - 1;
		var result = new Date(this.resolucion.dfechaexpedicion);
		result.setMonth(result.getMonth() + temp);
		this.resolucion.dfechavencimiento = new Date(result.getFullYear(), (result.getMonth() + 1), result.getDate());
	}

	private cargarListas() {

		this.tiposPrefijos = new Array();
		this.tiposFormatos = new Array();
		this.tiposDetalles = new Array();

		this._serviciosGenerales.get('tiposPrefijos', { param: 0 }).subscribe(
			result => {
				for (let x in result) {
					this.tiposPrefijos.push(new OpcionModel(result[x].ntipodoc, result[x].vdescripcion));
					console.log(result[x].ntipodoc, ' -- ', result[x].vdescripcion, ' -- ', new OpcionModel(result[x].ntipodoc, result[x].vdescripcion));

				}
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de prefijos", "X");
			})

		this._serviciosGenerales.get('tiposFormatos', { param: 0 }).subscribe(
			result => {
				for (let x in result)
					this.tiposFormatos.push(new OpcionModel(result[x].nidformato, result[x].vdescripcion));
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de formatos", "X");
			}
		)
		this._serviciosGenerales.get('tiposDetalles', { param: 0 }).subscribe(
			result => {
				for (let x in result)
					this.tiposDetalles.push(new OpcionModel(result[x].ndetallefact, result[x].vdescripcion));
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de detalles", "X");
			}
		)
	}


	private inicializarForm() {
		this.form = this.formBuilder.group({

			cprefijo: [{ disabled: this.bloquearCampo, value: (this.bloquearCampo == true ? this.prefijo.id.cprefijo : '') }, Validators.compose([Validators.required, Validators.pattern("^[a-zA-Z0-9_.-]*$")])],
			nnuminicio: [{ disabled: this.bloquearCampo, value: (this.bloquearCampo == true ? this.prefijo.nnuminicio : '') }, []],
			ntipodoc: ['', Validators.required],
			nidformato: ['3', Validators.required],
			ndetallefact: ['1', Validators.required],
			vformpago: ['', Validators.required],
			vtexto1: ['', Validators.required],
			vtexto2: ['', Validators.required],
			vtexto3: ['', Validators.required],
			vtexto4: ['', Validators.required],
			vtexto5: [''],
			vtexto6: [''],
			ndesde: [{ disabled: this.bloquearCampo, value: this.resolucion.ndesde }, Validators.required],
			nhasta: [{ disabled: this.bloquearCampo, value: this.resolucion.nhasta }, Validators.required],
			nmesesresolucion: [{ disabled: this.bloquearCampo, value: this.resolucion.nmesesresolucion }, Validators.required],
			dfechaexpedicion: [{ disabled: this.bloquearCampo, value: this.resolucion.dfechaexpedicion }, Validators.required],
			dfechavencimiento: [{ value: '', disabled: true }],
			cdescripcion: [''],
			ndiasvenc: ['', Validators.required],
			cprefijohomologo: [{ disabled: this.bloquearCampo, value: this.cprefijohomologo }, Validators.compose([Validators.required, Validators.pattern("^[a-zA-Z0-9_.-]*$")])]
		});

	}


	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}
	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Prefijo/Prefijo.component.ts